import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';
import Cycle from './cycle';
import CycleDetail from './cycle-detail';
import CycleMatieresView from './cycle-matieres-view';
import CycleUpdate from './cycle-update';
import CycleDeleteDialog from './cycle-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/new`} component={CycleUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/:id/edit`} component={CycleUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/:id/matieres`} component={CycleMatieresView} />
      <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/:anneeScolaireId/new`} component={CycleUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/:anneeScolaireId/:id/edit`} component={CycleUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/:anneeScolaireId/:id/matieres`} component={CycleMatieresView} />
      <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/:anneeScolaireId/:id`} component={CycleDetail} />
      <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/:anneeScolaireId`} component={Cycle} />
      <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/:id`} component={CycleDetail} />
      <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid`} component={Cycle} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/:anneeScolaireId/:id/delete`} component={CycleDeleteDialog} />
    <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/:id/delete`} component={CycleDeleteDialog} />
  </>
);

export default Routes;
